(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["seulab-ingredient-discovery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';
    const tabs = [...root.querySelectorAll('[data-tab]')];
    const panels = [...root.querySelectorAll('[data-panel]')];
    tabs.forEach(tab => tab.addEventListener('click', () => {
      const id = tab.dataset.tab;
      tabs.forEach(item => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(panel => panel.hidden = panel.dataset.panel !== id);
    }));
  };
  const initAll = scope => scope.querySelectorAll('[data-seulab-ingredient-edit]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', e => initAll(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seulab-routine-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.seulab-routine-bundle';

    const getCurrentProductVariant = (root, fallback) => {
      const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).filter((form) => !root.contains(form));
      for (const form of forms) {
        const input = form.querySelector('input[name="id"], select[name="id"]');
        if (input && input.value) return input.value;
      }
      return fallback;
    };

    const bindBundle = (root) => {
      if (!root || root.dataset.bundleBound === 'true') return;

      const checkboxes = Array.from(root.querySelectorAll('.seulab-routine-selector'));
      if (checkboxes.length < 2) {
        root.hidden = true;
        return;
      }

      root.dataset.bundleBound = 'true';
      root.hidden = false;

      const button = root.querySelector('[data-routine-add]');
      const countNode = root.querySelector('[data-routine-count]');
      const statusNode = root.querySelector('[data-routine-status]');
      const defaultButtonText = button ? button.textContent.trim() : '';

      const updateSelection = () => {
        let selectedCount = 0;
        checkboxes.forEach((checkbox) => {
          const card = checkbox.closest('.seulab-routine-card');
          if (checkbox.checked) selectedCount += 1;
          if (card) card.classList.toggle('is-selected', checkbox.checked);
        });
        if (countNode) countNode.textContent = `${selectedCount} ürün seçili`;
        if (button) button.disabled = selectedCount < 2;
        if (statusNode && selectedCount >= 2) statusNode.textContent = '';
      };

      checkboxes.forEach((checkbox) => checkbox.addEventListener('change', updateSelection));
      updateSelection();

      if (!button) return;

      button.addEventListener('click', async () => {
        const selected = checkboxes.filter((checkbox) => checkbox.checked);
        if (selected.length < 2) {
          if (statusNode) statusNode.textContent = 'Rutin avantajı için en az 2 ürün seçmelisin.';
          return;
        }

        const items = selected.map((checkbox) => {
          let variantId = checkbox.dataset.variantId;
          if (checkbox.dataset.current === 'true') {
            variantId = getCurrentProductVariant(root, variantId);
          }
          return { id: Number(variantId), quantity: 1 };
        }).filter((item) => Number.isFinite(item.id));

        if (items.length < 2) {
          if (statusNode) statusNode.textContent = 'Ürün seçenekleri sepete eklenemedi. Lütfen tekrar dene.';
          return;
        }

        button.disabled = true;
        button.textContent = 'SEPETE EKLENİYOR…';
        if (statusNode) statusNode.textContent = '';

        try {
          const rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
          const response = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) throw new Error('Cart add failed');

          const code = root.dataset.discountCode;
          if (code) {
            window.location.assign(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart')}`);
          } else {
            window.location.assign('/cart');
          }
        } catch (error) {
          button.disabled = false;
          button.textContent = defaultButtonText;
          if (statusNode) statusNode.textContent = 'Sepete eklerken bir sorun oluştu. Lütfen tekrar dene.';
        }
      });
    };

    const hydrateBundle = async (root) => {
      if (!root || root.dataset.bundleHydrated === 'true') return;
      root.dataset.bundleHydrated = 'true';

      if (root.dataset.performed === 'true') {
        bindBundle(root);
        return;
      }

      const url = root.dataset.recommendationsUrl;
      if (!url) return;

      try {
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Recommendations failed');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fetchedRoot = doc.getElementById(root.id);
        const fetchedDynamic = fetchedRoot ? fetchedRoot.querySelector('.seulab-routine-bundle__dynamic') : null;
        const dynamic = root.querySelector('.seulab-routine-bundle__dynamic');

        if (!fetchedDynamic || !dynamic) {
          root.hidden = true;
          return;
        }

        dynamic.innerHTML = fetchedDynamic.innerHTML;
        root.dataset.performed = 'true';
        bindBundle(root);
      } catch (error) {
        root.hidden = true;
      }
    };

    const init = (scope) => {
      if (!scope) return;
      if (scope.matches && scope.matches(selector)) hydrateBundle(scope);
      if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(hydrateBundle);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
